var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isEnabled
    ? _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "welcome-dialog-generic",
            fullscreen: "",
            persistent: ""
          },
          model: {
            value: _vm.isWelcomePage,
            callback: function($$v) {
              _vm.isWelcomePage = $$v
            },
            expression: "isWelcomePage"
          }
        },
        [
          _c("v-btn", { staticClass: "close", on: { click: _vm.close } }),
          _vm._v(" "),
          _c("static-content", {
            staticClass: "welcome",
            attrs: {
              staticcontentpath:
                "/static/static-content/" + _vm.$i18n.locale + "/welcome.html",
              method: "html",
              fullPath: ""
            }
          }),
          _vm._v(" "),
          _c("static-content", {
            staticClass: "footer",
            attrs: {
              staticcontentpath:
                "/static/static-content/" + _vm.$i18n.locale + "/footer.html",
              method: "html",
              fullPath: ""
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fdcedba4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fdcedba4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Welcome.vue
// module id = null
// module chunks = 